<script setup>
import { computed } from 'vue';
  import { useMapUIStore } from '@/stores/MapUIStore';
  import { useStormStore } from "@/stores/StormStore";
  import { useMapStore } from "@/stores/MapStore";
  import { useProductStore } from "@/stores/ProductStore";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import MapSidebarPinnedMaps from "@/components/MapSidebarPinnedMaps.vue";
  import MapButtonSidebar from "@/components/MapButtonSidebar.vue";
  import Icon from '@/components/icons/Icon.vue';
  import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';

  const {
    $PINNED_MAP_BAR,
    $MAP_CUSTOM_LAYERS,
    $MAP_SELECTOR_BUTTON,
    $FAVORITES_BUTTON,
    $CUSTOMIZE_MAP_BUTTON, 
    $MESONET_FILTER_BUTTON,
    $STORM_MAP_SELECTOR_BUTTON,
  } = useMapConfigurationGlobals();

  const mapUIStore = useMapUIStore();
  const stormStore = useStormStore();
  const mapStore = useMapStore();
  const productStore = useProductStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const showLayersDashboardButton = computed(() => !isDesktop.value && (mapStore.state.overlays['watches-warnings'] || mapStore.state.overlays['dsat-operating-condition'] || mapStore.state.overlays['lightning']));
  

</script>

<template>
  <div class="jwx-sidebar" data-map="sidebar">

    <div class="jwx-sidebar__primary">
      <div 
        v-if="$MAP_SELECTOR_BUTTON"
        class="jwx-map-block"
      >
        <MapButtonSidebar 
          class="jwx-map-button--primary" 
          type="config" 
          content="map-selection"
          accessibleLabel="Map Selector"
        >
          <Icon name="map" class="jwx-map-button__icon" />  
        </MapButtonSidebar>
      </div>
      <div
        v-if="$STORM_MAP_SELECTOR_BUTTON"
        class="jwx-map-block"
      >
        <MapButtonSidebar
          class="jwx-map-button--primary" 
          type="config" 
          content="storm-selection"
          accessibleLabel="Storm Selection"
        >
          <Icon name="hurricane" class="jwx-map-button__icon" />
          <span v-if="stormStore.activeStorms.length > 0" class="jwx-map-button__badge-count">{{ stormStore.activeStorms.length }}</span>
        </MapButtonSidebar>
      </div>
    </div>

    <Suspense>
      <MapSidebarPinnedMaps v-if="$PINNED_MAP_BAR" />
    </Suspense>

    <div v-if="showLayersDashboardButton" class="jwx-sidebar__secondary jwx-map-block jwx-map-block--transparent-border jwx-map-block--column">
      <ul class="jwx-map-block__content jwx-map-block__items">
        <li class="jwx-map-block__item">
          <MapButtonSidebar
            type="config"
            content="layers-dashboard"
            accessibleLabel="Layers Dashboard"
          >
          <Icon name="dashboard" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>    
        </ul> 
    </div>

    <div class="jwx-sidebar__secondary jwx-map-block jwx-map-block--transparent-border jwx-map-block--column">
      <ul class="jwx-map-block__content jwx-map-block__items" :data-reverse="!isDesktop || null">
        <li class="jwx-map-block__item" v-if="$FAVORITES_BUTTON">
          <MapButtonSidebar
          type="config"
          content="favorites"
          accessibleLabel="Favorites List"
        >
          <Icon name="favorites-folder" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>
        <li class="jwx-map-block__item" v-if="$MAP_CUSTOM_LAYERS && productStore.customLayers.length > 0">
          <MapButtonSidebar
          type="config"
          content="map-custom-layers"
          accessibleLabel="Map Custom Layers"
        >
          <Icon name="custom-layers" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>   
        <li v-if="mapUIStore.showCustomizeMapButton && $CUSTOMIZE_MAP_BUTTON" class="jwx-map-block__item">
          <MapButtonSidebar
            type="config"
            content="customization"
            accessibleLabel="Customize Map"
          >
            <Icon name="sliders" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>   
        <li v-if="mapUIStore.showSpotFilterButton && $MESONET_FILTER_BUTTON" class="jwx-map-block__item">
          <MapButtonSidebar
            type="config"
            content="storm-print-mesonet"
            accessibleLabel="Mesonet Filter"
          >
            <Icon name="filter" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>              
        <li class="jwx-map-block__item">
          <MapButtonSidebar
            type="config"
            content="settings"
            accessibleLabel="Map Settings"
          >
            <Icon name="gear" class="jwx-map-button__icon" />  
          </MapButtonSidebar>
        </li>        
      </ul>
    </div>

  </div>
</template>